import { CalendarView } from './CalendarView.main';

export { CalendarView };
